<div style="width: 100%;">
    <div class="controls">
        <button mat-stroked-button color="primary" (click)="getFilledFields()" [disabled]="submiting">
            <mat-icon>refresh</mat-icon>
            Carregar dados
        </button>
    </div>

    <ng-container *ngIf="submiting">
        <div class="empty-content" style="width: 100%">
            <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
        </div>
    </ng-container>

    <ng-container *ngIf="submiting == false">

        <ng-container *ngIf="barChartData == null">
            <div class="empty-content" style="width: 100%">
                Resultado do filtro aparecerá aqui
            </div>
        </ng-container>

        <ng-container *ngIf="barChartData?.length == 0">
            <div class="empty-content" style="width: 100%">
                Nenhum resultado encontrado!
            </div>
        </ng-container>

        <ng-container *ngIf="barChartData?.length > 0">
            <div style="
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                ">
                <div #barChartContainer style="flex: 1">
                    <h2 style="padding: 10px">Campos preenchidos</h2>
                    <div style="width: 100%">
                        <ngx-charts-bar-horizontal [view]="[barChartWidth, barChartWidth * 2]" [results]="barChartData"
                            [gradient]="false" [xAxis]="true" [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                            [showYAxisLabel]="true" xAxisLabel="Quantidades" yAxisLabel="Cargos">
                        </ngx-charts-bar-horizontal>
                    </div>
                </div>
                <div #pieChartContainer style="flex: 1">
                    <ngx-charts-pie-chart [view]="[pieChartWidth, pieChartWidth]" [results]="pieChartData"
                        [gradient]="false" [legend]="true" legendTitle="Legenda" [labels]="false" [doughnut]="false">
                    </ngx-charts-pie-chart>
                </div>
            </div>
        </ng-container>

    </ng-container>
</div>